import { Flex, Text } from "@chakra-ui/react";
import { theme } from "@ovou-inc/ovou-ui";
import { FC, ReactNode } from "react";
import { FiInfo } from "react-icons/fi";

interface IInfoBanner {
  description: ReactNode;
  fontSize?: string;
  fontWeight?: string;
  showIcon?: boolean;
}

export const InfoBanner: FC<IInfoBanner> = ({
  description,
  fontSize = "12px",
  fontWeight = "600",
  showIcon = true,
}) => {
  return (
    <Flex p="16px" borderRadius="8px" alignItems="center" gap="16px">
      {showIcon && <FiInfo size={24} color={theme.palette.ui.greys.grey1} />}
      <Text fontSize={fontSize} fontWeight={fontWeight} lineHeight="150%">
        {description}
      </Text>
    </Flex>
  );
};
